var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('search-bar',{attrs:{"loading":_vm.loading,"input-label":"Логін або ПІП студента..."},on:{"search":function($event){return _vm.getItemsSearch($event)}}}),_c('v-flex',{attrs:{"xs12":""}},[_c('admin-home-student-grid',{attrs:{"items":_vm.items,"total":_vm.total,"loading":_vm.loading},on:{"paginate":_vm.onPaginate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }